//type
import { carType } from "../../api/Cars/type/CarsType"

//mui icons
import StarIcon from '@mui/icons-material/Star';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import WeekendOutlinedIcon from '@mui/icons-material/WeekendOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';


//translate
import { useTranslation } from 'react-i18next';
import i18n from "../../translate/i18n";


interface bestCarsProps {
  element: carType
}

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

const CarCard = ({element}:bestCarsProps) => {
  const {t} = useTranslation()
  return (
    <div className="rounded-[15px] border-[1px] border-solid border-darkColor overflow-hidden group relative">
      <div className={`${element?.offers?.length > 0 ? "absolute top-1 z-10 right-3 bg-red-600 text-white p-2 rounded-full" : "hidden"} bg-red-600 text-white p-2 rounded-full flex items-center gap-2`}>
        <LocalOfferIcon className="!text-[15px]"/>
        <p className="text-[10px]">{t("offer")}</p>
      </div>
      <div className="lg:h-[200px] max-lg:h-[150px] w-full relative overflow-hidden rounded-t-[15px]">
          <img 
          className='h-full w-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-[1.5]' 
          src={`${storageURL}/${element.primary_images[0]?.url}`} 
          alt="no_photo"
          loading="lazy"
          decoding="async"
          />
          <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className={`text-white ${element?.fuel_type === "electric" ? "!bg-electricColor" : "!bg-customerColor"} p-3 rounded-full ${element?.fuel_type === "electric" ? "!bg-electricColor hover:!bg-electricColor/70": "hover:bg-customerColor/70"}`}>
              <VisibilityIcon  fontSize="large" />
            </div>
          </div>
      </div>
      <div className="p-3 mt-3">
        <p className="font-[600] truncate">{element.brand.name} - {element?.model?.name}</p>
        <div className="text-[#7F7F7F] text-sm">
          <div className="flex items-center gap-2 mt-2">
            <StarIcon  className="!text-[#FF8F3A]"/>
            <p>{element.avg_rate}</p>
          </div>
          {/* <div className="flex items-center gap-2 mt-2">
            <LocationOnOutlinedIcon/>
            <p>{i18n.language === "en" ? "Damascus, SY" : "دمشق, سوريا"}</p>
          </div> */}
          <div className="flex items-center gap-2 mt-2">
            <WeekendOutlinedIcon/>
            <p>{element.seating_capacity} {t("seats")}</p>
          </div>
          <div>
            {
              element.is_daily !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.daily_price))} / {t("day")}</p>
                </div>
              :
              element.is_weekly !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.weekly_price))} / {t("week")}</p>
                </div>
              :
              element.is_monthly !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.monthly_price))} / {t("month")}</p>
                </div>
              :
              <></>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default CarCard